import React from 'react';
import { Card, CardHeader, CardContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import StatusChip from './StatusChip';
const msgs = defineMessages({
    headerTitle: {
        id: 'pages.member.vehicle.GpsCard.header.title',
        defaultMessage: 'GPS',
    },
    headerSubTitle: {
        id: 'pages.member.vehicle.GpsCard.header.subTitle',
        defaultMessage: 'GPS reading',
    },
});
function GpsCard({ realtimeMetrics, lastMetrics }) {
    const intl = useIntl();
    const gpses = realtimeMetrics?.filter((e) => e.gps).map((e) => e.gps);
    const gps = gpses && gpses.length > 0 ? gpses[gpses.length - 1] : lastMetrics?.gps;
    return (React.createElement(Card, null,
        React.createElement(CardHeader, { title: intl.formatMessage(msgs.headerTitle), subheader: intl.formatMessage(msgs.headerSubTitle), action: React.createElement(StatusChip, { realtimeMetrics: realtimeMetrics, lastMetrics: lastMetrics, hasField: (e) => !!e.gps }) }),
        React.createElement(CardContent, null, gps ? (React.createElement(TableContainer, { component: Paper, elevation: 0 },
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { align: "right" }, "EPH"),
                        React.createElement(TableCell, { align: "right" }, "EPV"),
                        React.createElement(TableCell, { align: "right" }, "Fix Type"),
                        React.createElement(TableCell, { align: "right" }, "Visible Sattelites"))),
                React.createElement(TableBody, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { align: "right" }, gps.eph?.toFixed(2) || '-'),
                        React.createElement(TableCell, { align: "right" }, gps.epv?.toFixed(2) || '-'),
                        React.createElement(TableCell, { align: "right" }, gps.fixType ?? '-'),
                        React.createElement(TableCell, { align: "right" }, gps.satellitesVisible || '-')))))) : (React.createElement(Typography, { variant: "body2" }, "No data.")))));
}
export default React.memo(GpsCard);
